import { AddNode, RemovedNode, ReplacedNode } from '@components/CaseActivityDrawer/types/CaseActivityRowType';
import { InsuranceAuthStatusResponse } from '@interfaces/InsuranceAuthStatus/InsuranceAuthStatusState.types';

export interface ChangeDetails extends Partial<ReplacedNode> {
	changeTitle?: string;
}

export interface FormatActivityChangeDetailsReturn {
	changedField: string;
	changeDetails: ChangeDetails;
	formattedTime?: string;
}

export const getFieldName = (change: ReplacedNode | AddNode | RemovedNode) => {
	return change.fieldFriendlyName.split('::');
};

export const formatDocumentChangeDetails = (change: AddNode | RemovedNode): FormatActivityChangeDetailsReturn => {
	const [changedField] = getFieldName(change);

	const changeDetails = {
		...change,
	};

	return { changedField, changeDetails };
}

export const formatActivityChangeDetails = (change: ReplacedNode, authStatusConfig: InsuranceAuthStatusResponse | undefined): FormatActivityChangeDetailsReturn => {
	const [changedField, procedureName] = getFieldName(change);

	const changedFieldDetails: Record<string, ChangeDetails> = {
		Authorization: {
			currValue: authStatusConfig?.[change.currValue]?.label,
			prevValue: authStatusConfig?.[change.prevValue]?.label,
		},
		Equipment: {
			changeTitle: `Procedure ${procedureName} was edited.`,
			currValue: change.currValue || 'No equipment',
			prevValue: change.prevValue || 'No equipment',
		},
	};

	const changeDetails = changedFieldDetails[changedField] || {
		...change,
	};

	return { changedField, changeDetails };
};
